import styled from 'styled-components';

interface ICheckboxInput {
  type: 'checkbox' | 'radio';
  selected?: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const CheckboxInput = styled.label<ICheckboxInput>`
  display: flex;
  align-items: center;

  span {
    color: #fff;
    font-weight: 500;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: ${(props) => (props.type === 'radio' ? '50%' : '4px')};
    margin-right: 8px;
    transition-duration: 0.3s;
    background: ${(props) => (props.selected ? '#2FB26C' : 'transparent')};
    border: 1px solid #2fb26c;

    div.check-icon {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #fff;
    }
  }

  .inputData {
    display: none;
  }

  + label {
    margin-left: 20px;
  }
`;

export const Error = styled.span`
  font-size: 11px !important;
`;
